import { GetBy } from '../_app/cuchillo/core/Element';
import { Icon } from './Icon';

// Finds all [data-svg-hover] elements and creates an Icon instance for each.
// Safe to init per page — dispose() cleanly removes all listeners and resets paths.
export default class IconsHover {
  static _items = [];

  static init(container = document) {
    [...GetBy.selector('[data-svg-hover]', container)].forEach(el => {
      this._items.push(new Icon(el));
    });
  }

  static dispose() {
    this._items.forEach(icon => icon.dispose());
    this._items = [];
  }
}
